import { Link } from 'react-router-dom';

export const configurationManagementMessages = {
  en: {
    title: 'Configuration Management',
    btnSave: 'Save',
    heading: 'Configuration Management Option',
    optionSyslogtrigger: 'Syslog Triggered',
    optionTimer: 'Timer',
    optionSchedule: 'Schedule',
    minutes: 'minutes',
    boxTitle: 'Configuration Management Setup',
    help: (
      <blockquote>
        <p>
          Configuration management backs up running configuration of managed
          network devices based on the defined trigger.
        </p>

        <ul className='list-unstyled'>
          <li>
            <strong>Syslog triggered</strong> requires syslog messages sent from
            devices to the IP Fabric appliance. IP Fabric checks incoming syslog
            messages for a specific string.
          </li>
          <li>
            <strong>Schedule</strong> enables periodic device configuration
            backup.
          </li>
        </ul>
        <p />
        <p>
          For proper functionality, at least one authentication user must have
          configuration management enabled. Go to{' '}
          <strong>
            <Link to='/settings/discovery-snapshots/global-discovery-settings'>
              {'Settings -> Discovery & Snapshots -> Discovery Settings'}
            </Link>
          </strong>
          , select the <strong>Device Credentials</strong> tab and check if any
          credentials are marked with <strong>Used in Config management</strong>{' '}
          label.
        </p>
      </blockquote>
    ),
    validation: {
      triggerRequired: 'Please choose download type',
      triggerTimeRequired: 'Please fill in download time',
      triggerNumber: 'Download time must be number',
      cronRequired: 'Please fill in schedule time',
    },
  },
};
